import {documents} from './Documents.reducer'

export * from './Documents.actions'
export * from './Documents.selector'
export * from './Action.types'
export * from './Documents.tools'
export * from './Documents.provider'

export const documentsReducer = documents
